import template from './action';
import events from './eventListener';
import './index.css';
import '../../../PopconfirmHTML/PopconfirmHTML.css';

export default {
  template,
  events
};
